import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showNotification, showAlert, catchHandler } from "../../utils/helpers";
import { status , employeeStatus} from "../../utils/common";

const state = {
    employees: [],
    names: [],
    employee: {
        administrativeInfo:{},
        financialInfo:{},
        sytemInfo:{},
    },
    totalItems:0,
};

const getters = {
    index: state => employeeId => state.employees.findIndex(i => i.employeeId === employeeId)
};

const mutations = {
    setEmployees: (state, r) => (state.employees = r),
    setTotalItems: (state, r) => (state.totalItems = r),

    setEmployee: (state, r) => (state.employee = r),
    add: (state, r) => state.employees.unshift(r),
    edit: (state, {index,  r }) => state.employees.splice(index, 1, r),
    delete: (state, index) => state.employees.splice(index, 1),
    lock: (state, index) => state.employees[index].status = status.locked,
    unlock: (state, index) => state.employees[index].status = status.active,
    return: (state) => state.employee.employeeStatus = employeeStatus.Alive,
    setNames: (state, r) => (state.names = r),
};

const actions = {
    async getAll({ commit }, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");

            startLoading()
            const response = await dataService.employees.getAll(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            commit("setEmployees", response.data.employees);
            commit("setTotalItems", response.data.totalItems);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getDetails({ commit }, id) {
        try {
            commit("setEmployee", {  administrativeInfo:{},
            financialInfo:{},
            sytemInfo:{},});
            startLoading()
            const response = await dataService.employees.getDetails(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setEmployee", response.data.employee);
           
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getForEdit(_, id) {
        try {
            startLoading()
            const response = await dataService.employees.getForEdit(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data);
         

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async add(_, payload) {
        try {
            console.log(payload)
            let formdata = new FormData()
            formdata.append("idCardPhoto", payload.idCardPhoto)
            formdata.append("IdCardPhotoName", payload.idCardPhoto)
            startLoading()
            const response = await dataService.employees.add(payload);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            return Promise.resolve(response.data.employee);
            //showNotification(response.data.message);
            //commit("add", response.data.employee);
       
        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    }, 

    async edit({ commit, getters }, { id, payload }) {
        try {
            //console.log(payload)
            //let formdata = new FormData()
            //formdata.append("idCardPhoto", payload.idCardPhoto)
            //formdata.append("IdCardPhotoName", payload.idCardPhoto)
            startLoading()
            const response = await dataService.employees.edit(id, payload);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            showNotification(response.data.message);

            const index = getters.index(response.data.employee.employeeId);
            commit("edit", { index, r: response.data.employee });
            return Promise.resolve()
        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async complete({ commit }, { id, payload }) {
        try {
            startLoading()
            const response = await dataService.employees.complete(id, payload);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            showNotification(response.data.message);

            commit("add", response.data.employee);
            return Promise.resolve(response.data.employee)

        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async delete({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.employees.delete(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);

            const index = getters.index(id);
            commit("delete", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async lock({ commit, getters }, {id, payload}) {
        try {
            let formdata = new FormData()
            formdata.append("description", payload.description);
            formdata.append("attachment", payload.attachment);

            startLoading()
            const response = await dataService.employees.lock(id,formdata);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);
            
            const index = getters.index(id);
            commit("lock", index);
        } catch (error) {
            console.log(error)
            stopLoading()
            catchHandler(error);
        }
    },
    async unlock({ commit, getters }, {id,payload}) {
        try {
            let formdata = new FormData()
            formdata.append("description", payload.description);
            formdata.append("attachment", payload.attachment);

            startLoading()
            const response = await dataService.employees.unlock(id,formdata);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);

            const index = getters.index(id);
            commit("unlock", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },

    async getImages(_, id) {
        try {
            startLoading()
            const response = await dataService.employees.getImages(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data.employee);


        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    
    async uploadImage(_, payload) {
        try {
          
            startLoading()
            const response = await dataService.employees.uploadImage(payload);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            showNotification(response.data.message);

        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },

    async checkName(_ , params) {
        try {

            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");
            const response = await dataService.employees.checkName(paramsString);

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
          
            return Promise.resolve(response.data);
        

        } catch (error) {
            catchHandler(error);
        }
    },


    async uploadMultiImage(_, { id, payload }) {
        try {
            console.log(id)
            console.log(payload.files);
            let formdata = new FormData()
            payload.files.forEach((file) => formdata.append("files", file))
            console.log(formdata);
            startLoading()
            const response = await dataService.employees.uploadMultiImage(id,formdata);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            showNotification(response.data.message);
            return Promise.resolve();
       
        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },  
      async getAttachmentsArchives(_, {id ,params}) {
        try {
            const paramsString = Object.entries(params)
            .filter(([, val]) => val !== null)
            .map(([key, val]) => `${key}=${val}`)
            .join("&");

            startLoading()
            const response = await dataService.employees.getAttachmentsArchives(id,paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            console.log(response.data);
            return Promise.resolve(response.data);
       
        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    //------------------------------------------------------//
    async getForEmploymentStatement(_, id) {
        try {
            startLoading()
            const response = await dataService.employees.getForEmploymentStatement(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data);
         

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    }, 
    // ------------------------------------------------------------------//
    async employeeReturn({ commit }, id) {
        try {
            startLoading()
            const response = await dataService.employees.employeeReturn(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);

        //    const index = getters.index(id);
            commit("return");
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
